import type {SeedQuestionStatus} from '@cp/model';
import {getCountFromServer, orderBy, query, where, type QueryConstraint} from 'firebase/firestore';
import getSeedQuestionCollectionRef from './getSeedQuestionCollectionRef';

export interface CountSeedQuestionsByFiltersDocParams {
  moduleId: string;
  topics?: string[];
  statuses?: SeedQuestionStatus[];
}

const FIRESTORE_IN_MAX = 10;

export default async function countSeedQuestionsByFiltersDoc(
  params: CountSeedQuestionsByFiltersDocParams,
): Promise<number> {
  const {moduleId, topics, statuses} = params;
  const col = getSeedQuestionCollectionRef(moduleId);
  const constraints: QueryConstraint[] = [orderBy('createdAt', 'desc')];
  if (topics && topics.length > 0) {
    if (topics.length > FIRESTORE_IN_MAX) {
      throw new Error(`At most ${FIRESTORE_IN_MAX} topics supported per query`);
    }
    constraints.push(where('topic', 'in', topics));
  }
  if (statuses && statuses.length > 0) {
    if (statuses.length > FIRESTORE_IN_MAX) {
      throw new Error(`At most ${FIRESTORE_IN_MAX} statuses supported per query`);
    }
    constraints.push(where('status', 'in', statuses));
  }
  const agg = await getCountFromServer(query(col, ...constraints));
  return agg.data().count;
}
